import { Box } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { BankConnectionRankingPageContent } from "Components/BankRanking/BankConnectionRankingPageContent";
import { Resources, useResource } from "Translations/Resources";

const BankConnectionRankingPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.BankRating.Title)}
      backNavigation={{ mode: "historyStack", fallbackUrl: null }}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <BankConnectionRankingPageContent />
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default BankConnectionRankingPage;
